// Libraries
import { get, map, includes } from 'lodash'
import PropTypes from 'prop-types'
import React, { Component } from 'react'

// Common components
import { TableLayout } from 'Components'

// Specs
import { TableSpecs } from 'Views/PreventionPlans/Specs'

// Styles
import './Styles/List.less'

class PreventionPlansList extends Component {
  static propTypes = {
    // TÃ©moin d'approvisionnement des donnÃ©es
    loading: PropTypes.bool,

    // DonnÃ©es de la vue
    dataList: PropTypes.array,

    // DonnÃ©es de construction du tableau
    TableSpecs: PropTypes.object,

    // Fonctions hÃ©ritÃ©s du constructeur
    constructorFunctions: PropTypes.objectOf(PropTypes.func),

    // Utilisateur connectÃ©
    profile: PropTypes.object
  }

  static defaultProps = {
    // TÃ©moin d'approvisionnement des donnÃ©es
    loading: true,

    // DonnÃ©es de la vue
    dataList: []
  }

  constructor(props) {
    super(props)

    this.state = {
      pagination: TableSpecs.pagination
    }
  }

  handleOnChange = pagination => {
    this.setState({ pagination })
  }

  render() {
    const { loading, dataList, constructorFunctions, profile } = this.props

    const isAdmin = map(get(profile, 'roles'), 'name').some(role =>
      includes(['ADMIN', 'SUPERADMIN'], role)
    )
    const { pagination } = this.state

    // Ajout des donnÃ©es au tableau
    TableSpecs.rows = dataList

    // Ajout des actions au clic sur un ligne du tableau
    TableSpecs.onRow = (preventionPlan, id) => ({
      onClick: () =>
        get(constructorFunctions, 'handleRowClick', () => {})(
          preventionPlan,
          id
        )
    })

    // Pagination courante
    TableSpecs.pagination = pagination
    TableSpecs.onChange = this.handleOnChange

    TableSpecs.onDraggedRowReleased = draggedData =>
      get(constructorFunctions, 'handleDraggedRowReleased', () => {})(
        draggedData
      )

    // VisibilitÃ© des boutons selon le rÃ´le
    TableSpecs.actions.global.create.hidden = !isAdmin
    TableSpecs.actions.selection.delete.hidden = !isAdmin

    // Ajout des actions multiples sur le tableau
    TableSpecs.actions.selection.delete.onClick = get(
      constructorFunctions,
      'askDeleteManyPreventionPlans'
    )

    // Ajout des actions des boutons
    TableSpecs.actions.global.create.onClick = get(
      constructorFunctions,
      'askCreatePreventionPlan'
    )

    return (
      <main className='screen preventionPlans preventionPlans-list'>
        <TableLayout loading={loading} {...TableSpecs} />
      </main>
    )
  }
}

export default PreventionPlansList
